var map = {
	"./16-Binare-Zahlen1.png": 4634,
	"./17-Binare-Zahlen2_schwimmender_Biber.png": 6135,
	"./17-Binare-Zahlen2_schwimmender_Biber_2.png": 6362,
	"./18-Binare-Zahlen3b.png": 1893,
	"./3_4_HB_p58.png": 5261,
	"./3_4_HB_p58_2.png": 177,
	"./5_6_Roemer_LF_Illu_p18.png": 2265,
	"./7_9_Daten_Kap1_binaer_rechnen.png": 7922,
	"./7_9_Daten_Kap2_Roemer_Pferd.png": 8072,
	"./Christbaum.png": 3355,
	"./Christbaum_Legende.png": 7178,
	"./Geburtstagskerzen.png": 8554,
	"./Geburtstagskerzen_Legende.png": 3609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4490;